module.exports = __webpack_public_path__ + "static/media/hsg-main-illustration.4ad6714d.png";